import { render, staticRenderFns } from "./ChartNinetyDaySales.vue?vue&type=template&id=0bce2e53&scoped=true&"
import script from "./ChartNinetyDaySales.vue?vue&type=script&lang=js&"
export * from "./ChartNinetyDaySales.vue?vue&type=script&lang=js&"
import style0 from "./ChartNinetyDaySales.vue?vue&type=style&index=0&id=0bce2e53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce2e53",
  null
  
)

export default component.exports